import { render, staticRenderFns } from "./HonorsSection.vue?vue&type=template&id=4d8cd684&scoped=true"
import script from "./HonorsSection.vue?vue&type=script&lang=js"
export * from "./HonorsSection.vue?vue&type=script&lang=js"
import style0 from "./HonorsSection.vue?vue&type=style&index=0&id=4d8cd684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8cd684",
  null
  
)

export default component.exports